export const PracticeMistakesLoggedInText =
    'Practice all the questions which you have skipped or answered wrongly while practicing with quiz challenge.';
export const PracticeMistakesLoggedOutText =
    'Log in to start playing quiz challenge to keep track of the questions you skip or answered wrongly, so that you can come back and practice them later.';

export const NoMistakesQuizFoundText =
    "Wow! Looks like you've not skipped any questions or answered anything wrongly yet. Go make some mistakes and they'll show up here!";
